/* Server-rendered Shopify results preserve product URLs and market currency. */
if (!customElements.get('fm-live-search')) customElements.define('fm-live-search', class extends HTMLElement {
  connectedCallback() {
    this.lifecycle?.abort(); this.lifecycle = new AbortController();
    this.input = this.querySelector('[name="q"]'); this.panel = this.querySelector('.fm-suggestions');
    this.results = this.querySelector('[data-fm-results]'); this.status = this.querySelector('[role="status"]'); this.all = this.querySelector('[data-fm-all]');
    const opts = {signal:this.lifecycle.signal};
    this.input.addEventListener('input', () => this.search(), opts);
    this.input.addEventListener('focus', () => {if(this.input.value.trim().length >= 2) this.search();}, opts);
    this.addEventListener('keydown', e => {
      if(e.key === 'Escape') {this.input.focus(); this.close(); return;}
      if(this.panel.hidden || !['ArrowDown','ArrowUp'].includes(e.key)) return;
      const links = [...this.panel.querySelectorAll('a[href]')]; if(!links.length) return;
      e.preventDefault(); const index = links.indexOf(document.activeElement);
      if(e.key === 'ArrowUp' && index === 0) this.input.focus();
      else links[e.key === 'ArrowDown' ? (index + 1) % links.length : (index < 0 ? links.length - 1 : index - 1)].focus();
    }, opts);
    this.panel.addEventListener('mousedown', e => e.preventDefault(), opts);
    this.addEventListener('focusout', e => {
      if (e.relatedTarget && this.contains(e.relatedTarget)) return;
      setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 150);
    }, opts);
    document.addEventListener('pointerdown', e => {if(!this.contains(e.target)) this.close();}, opts);
  }
  disconnectedCallback() {this.close(); this.lifecycle?.abort();}
  close() {clearTimeout(this.timer); this.request?.abort(); this.serial = (this.serial || 0) + 1; this.panel.hidden = true; this.input.setAttribute('aria-expanded','false');}
  search() {
    clearTimeout(this.timer); this.request?.abort(); const serial = this.serial = (this.serial || 0) + 1;
    const query = this.input.value.trim();
    if(query.length < 2) {this.close();return;}
    const url = new URL(this.querySelector('form').action); url.search = new URLSearchParams({q:query,type:'product','options[prefix]':'last'});
    this.all.href = url.href; this.results.replaceChildren(); this.status.textContent = 'Αναζήτηση…';
    this.panel.hidden = false; this.input.setAttribute('aria-expanded','true');
    this.timer = setTimeout(() => this.fetchResults(query,serial),220);
  }
  async fetchResults(query,serial) {
    const controller = this.request = new AbortController();
    const timeout = setTimeout(() => controller.abort(),8000);
    try {
      const url = new URL(this.dataset.endpoint,location.origin);
      url.search = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'6','resources[options][unavailable_products]':'last',section_id:'fm-predictive-results'});
      const response = await fetch(url,{signal:controller.signal,headers:{Accept:'text/html'}});
      if(!response.ok) throw new Error('Search unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const content = doc.querySelector('[data-fm-response]'); if(!content) throw new Error('Missing results');
      if(serial !== this.serial) return;
      this.results.replaceChildren(...Array.from(content.childNodes));
      const count = Number(content.dataset.count);
      this.status.textContent = count ? `${count} προτάσεις πινάκων` : 'Δεν βρέθηκαν προτάσεις. Δοκίμασε άλλο όνομα ή δες όλα τα αποτελέσματα.';
    } catch(error) {
      if(serial !== this.serial) return;
      this.results.replaceChildren(); this.status.textContent = 'Η προεπισκόπηση δεν είναι διαθέσιμη. Πάτησε Enter ή δες όλα τα αποτελέσματα.';
    } finally {clearTimeout(timeout);}
  }
});
